import { atom } from "recoil";
export const caseReportDataState = atom({
    key: "caseReportDataState", // unique ID (with respect to other atoms/selectors)
    default: "", // default value (aka initial value)
});
